import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { getEnvironment } from 'src/shared/helpers/environment.helper';
import { PageListItem } from './osc-reference-app-common/interfaces/page-list-item';
import { OscEnvironment } from './osc-utils/enums/osc-environments';
import { environment } from 'src/environments/environment';
import { UserProfile } from './osc-utils/models/user-profile';
import { AuthService } from './osc-utils/authentication/auth-service';
import { Router, RouterModule } from '@angular/router';
import { OscUtilsModule } from './osc-utils/osc-utils.module';
import { OscReferenceAppCommonModule } from './osc-reference-app-common/osc-reference-app-common.module';
import { AppIdentity, PlatformComponent, PlatformService } from '@evc/platform';
import { of } from 'rxjs';
import { AsyncPipe, NgIf } from '@angular/common';
import { InspectionSetupComponent } from './inspection-setup/inspection-setup.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [
    RouterModule,
    OscUtilsModule,
    OscReferenceAppCommonModule,    
    PlatformComponent,
    InspectionSetupComponent,
    AsyncPipe,
    NgIf
  ],
})
export class AppComponent implements OnInit {
  public appIdentification: AppIdentity;
  public appName = 'VANTA DATA APP';
  public pageList: PageListItem[] = [
    {
      displayName: 'DATA VIEWER',
      routerPath: '/viewer',
      icon: 'icon-list',
      active: true,
      activePredicate: url => url.startsWith('/viewer'),
    },
  ];

  public oscEnvironment: OscEnvironment;
  public currentUser: UserProfile;
  public useEVCPlatform = environment.USE_CONNECT_PLATFORM;
  public ready$ = this.useEVCPlatform ? this.platformService.ready$ : of(true);

  constructor(
    private authService: AuthService,
    private translate: TranslateService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,    
    private router: Router,
    private platformService: PlatformService,
  ) {
    translate.setDefaultLang('en');
    translate.use('en');
  }

  public ngOnInit() {
    this.initEvcPlatform();
    this.iconRegistry.addSvgIconSet(this.sanitizer.bypassSecurityTrustResourceUrl('assets/sprite/sprite.svg'));
    if (!this.useEVCPlatform) {
      this.authService.getCurrentUserProfile().then(user => {
        this.currentUser = user;
      });
      this.authService.reloadPageOnLogout();
    }
    this.translate.get(['appTitle', 'dataViewer.dataViewerTitle']).subscribe(translation => {
      this.appName = translation.appTitle;
      this.pageList[0].displayName = translation['dataViewer.dataViewerTitle'];
    });
    this.oscEnvironment = getEnvironment();
  }

  private initEvcPlatform() {
    this.setEvcPlatformOptions();
  }

  private setEvcPlatformOptions(): void {
    this.appIdentification = {
      name: 'VANTA DATA APP',
      title: 'Vanta Data Viewer',
      logo: '/assets/img/device-vanta-blue.svg',
      onTitleClick: () => this.router.navigateByUrl('/viewer'),
      version: '2026.6',
    };
  }
}
